import { SET_SEARCH_TEXT_ACTION, SET_ONLY_PADRAO_ACTION } from './actions.type';
import { SET_SEARCH_TEXT, SET_ONLY_PADRAO } from './mutations.type';

export default {
  [SET_SEARCH_TEXT_ACTION](context, text) {
    context.commit(SET_SEARCH_TEXT, text);
  },
  [SET_ONLY_PADRAO_ACTION](context, onlyPadrao) {
    context.commit(SET_ONLY_PADRAO, onlyPadrao);
  },
};
